import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  id: "Nav",
  class: "left",
  "data-login": ""
}
const _hoisted_3 = { class: "back" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = {
  key: 0,
  class: "buttons"
}
const _hoisted_9 = {
  class: "cta secondary s16",
  "data-color": "white"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = ["action"]
const _hoisted_12 = { class: "or" }
const _hoisted_13 = ["value"]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  id: "Main",
  class: "right"
}
const _hoisted_17 = {
  class: "logo",
  "data-color": "cyan50"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = ["alt"]
const _hoisted_20 = { class: "intro" }
const _hoisted_21 = { class: "maintitle s36" }
const _hoisted_22 = {
  ref: "form",
  class: "form"
}
const _hoisted_23 = { class: "item" }
const _hoisted_24 = { for: "UserName" }
const _hoisted_25 = {
  key: 0,
  class: "desc small"
}
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "item" }
const _hoisted_28 = { for: "Password" }
const _hoisted_29 = {
  class: "custominput",
  "data-type": "passwordremind"
}
const _hoisted_30 = ["href"]
const _hoisted_31 = { class: "item" }
const _hoisted_32 = { class: "checkbox" }
const _hoisted_33 = { for: "IsPersistent" }
const _hoisted_34 = ["data-tooltip"]
const _hoisted_35 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_36 = { class: "cta" }
const _hoisted_37 = {
  key: 1,
  class: "content"
}
const _hoisted_38 = { class: "intro" }
const _hoisted_39 = { class: "maintitle s36" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = {
  class: "item",
  "data-label": "top"
}
const _hoisted_42 = ["aria-label"]
const _hoisted_43 = ["data-index"]
const _hoisted_44 = {
  key: 0,
  class: "item validation-summary-errors"
}
const _hoisted_45 = { class: "item" }
const _hoisted_46 = { class: "cta" }

import { ref, nextTick, onBeforeMount } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountLogin',
  props: {
    returnUrl: {}
  },
  setup(__props: any) {

const props = __props;

const localizer = Localizer;
const formHelper = FormHelper;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const isLoginVisible = ref(false);
const isTwoFactorVisible = ref(false);
const isTwoFactorRetryVisible = ref(false);
const options = ref<any>(null);
const formData = ref<any>({ isPersistent: false });
const twoFactorData = ref<any>({ code: null });
const codeInputArray = ref([0, 1, 2, 3, 4, 5]);
const codeInputs = ref<HTMLInputElement[]>([]);
const validationErrors = ref<any[]>([]);
const isHidden = ref(true);

onBeforeMount(async () => {
    options.value = (await Axios.post(routes.Account_User_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    isLoginVisible.value = true;
});

async function submitForm() {
    FormHelper.removeFocus();
    validationErrors.value = [];
    isLoading.value = true;
    try {
        let result = (await Axios.post(routes.Account_User_Login, formData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
        if (!result.isTwoFactorRequired) {
            isSuccess.value = true;
            if (result.redirectUrl && props.returnUrl) {
                result.redirectUrl = result.redirectUrl + '?returnUrl=' + props.returnUrl;
            }
            window.location.href = result.redirectUrl ? result.redirectUrl : (props.returnUrl ? props.returnUrl : "/");
        } else {
            await sendTwoFactorCode();
            isLoginVisible.value = false;
            isTwoFactorVisible.value = true;

            nextTick(() => {
                inputTwoFactorCode();
            });
        }
    } catch (error: any) {
        formData.value.password = null;
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }
    isLoading.value = false;
}

async function submitTwoFactor() {
    FormHelper.removeFocus();
    validationErrors.value = [];
    isLoading.value = true;

    twoFactorData.value.isPersistent = formData.value.isPersistent;

    try {
        let result = (await Axios.post(routes.Account_User_TwoFactorValidate, twoFactorData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
        isSuccess.value = true;

        if (result.redirectUrl && props.returnUrl) {
            result.redirectUrl = result.redirectUrl + "?returnUrl=" + props.returnUrl;
        }

        window.location.href = result.redirectUrl ? result.redirectUrl : (props.returnUrl ? props.returnUrl : "/");
    } catch (error: any) {
        isLoading.value = false;
        twoFactorData.value.code = null;

        if (error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }
}

async function sendTwoFactorCode() {
    FormHelper.removeFocus();
    validationErrors.value = [];
    isLoading.value = true;
    isTwoFactorRetryVisible.value = false;

    try {
        await Axios.post(routes.Account_User_TwoFactorSend, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });

        setTimeout(() => {
            isTwoFactorRetryVisible.value = true;
        }, 5000);
    } catch (error: any) {
        twoFactorData.value.code = null;

        if (error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoading.value = false;
}

function inputTwoFactorCode() {
    const inputs = codeInputs.value;

    inputs.forEach((input, index) => {
        input.addEventListener("input", (e: Event) => {
            const target = e.target as HTMLInputElement;
            target.value = target.value.replace(/\D/g, "");
            target.classList.remove("error");
            updateHiddenInput();
            if (target.value && index < inputs.length - 1) {
                inputs[index + 1].focus();
            }
        });

        input.addEventListener("keydown", (e: KeyboardEvent) => {
            if (e.key === "Backspace" && !input.value && index > 0) {
                inputs[index - 1].focus();
            }
        });

        input.addEventListener("paste", (e: ClipboardEvent) => {
            e.preventDefault();
            const pasteData = e.clipboardData?.getData("text") || "";
            const digits = pasteData.replace(/\D/g, "");

            if (digits.length === inputs.length) {
                inputs.forEach((input, i) => {
                    input.value = digits[i] || "";
                });
                updateHiddenInput();
                inputs[inputs.length - 1].focus();
            }
        });
    });

    function updateHiddenInput(): void {
        twoFactorData.value.code = Array.from(inputs).map(input => input.value).join("");
    }
}

function isEmailNotConfirmed(): boolean {
    return (validationErrors.value.length !== 0 && validationErrors.value.some((x: any) => x.message === localizer.get("Account.Common.Login_EmailNotConfirmed")));
}

function showPasswordIcon() {
    isHidden.value = !isHidden.value;
}

function goBack() {
    window.location.href = routes.Home;
}

return (_ctx: any,_cache: any) => {
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack())),
          class: "button icon fastic-circle-left",
          "aria-label": _unref(localizer).get('App.Common.PageBack')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", {
          class: "maintitle s60",
          innerHTML: _unref(localizer).get('Account.Login.MyBeghelliTitle')
        }, null, 8, _hoisted_6),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(localizer).get("Account.Login.MyBeghelliDesc")), 1),
        (options.value && options.value.externalProviders.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("a", {
                  href: _unref(routes).Account_User_Register + (__props.returnUrl ? '?returnurl=' + __props.returnUrl : ''),
                  class: "button"
                }, _toDisplayString(_unref(localizer).get("Account.Login.CreateProfile")), 9, _hoisted_10)
              ]),
              _createElementVNode("form", {
                action: _unref(routes).Account_External_ExternalLogin + (__props.returnUrl ? '?returnurl=' + __props.returnUrl : ''),
                method: "post",
                class: "external"
              }, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(localizer).get("App.Common.Or")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value.externalProviders, (provider, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "cta secondary s16 icon",
                      "data-color": "white"
                    }, [
                      _createElementVNode("button", {
                        type: "submit",
                        name: "provider",
                        value: provider.name,
                        class: "button"
                      }, [
                        _createElementVNode("img", {
                          src: '/images/' + provider.name + '.svg',
                          width: "20",
                          height: "20",
                          class: "icon",
                          alt: provider.name
                        }, null, 8, _hoisted_14),
                        _createTextVNode(_toDisplayString(_unref(localizer).get("Account.ExternalRegister.Login", provider.name)), 1)
                      ], 8, _hoisted_13)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("input", {
                  type: "hidden",
                  name: "__RequestVerificationToken",
                  value: _unref(formHelper).getRequestVerificationToken()
                }, null, 8, _hoisted_15)
              ], 8, _hoisted_11)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_app_footer)
    ]),
    _createElementVNode("main", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("a", {
          href: _unref(routes).Home
        }, [
          _createElementVNode("img", {
            src: "/images/logo.svg",
            width: "125",
            height: "35",
            alt: _unref(localizer).get('App.Common.Beghelli')
          }, null, 8, _hoisted_19)
        ], 8, _hoisted_18)
      ]),
      (isLoginVisible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (submitForm()), ["prevent","stop"]), ["enter"])),
            class: "content"
          }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h2", _hoisted_21, _toDisplayString(_unref(localizer).get("Account.Login.LoginTitle")), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(localizer).get("Account.Common.EmailOrUserName")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "UserName",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.userName) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('UserName', validationErrors.value) }, 'input w300'])
                  }, null, 2), [
                    [
                      _vModelText,
                      formData.value.userName,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                (isEmailNotConfirmed())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("a", {
                        href: _unref(routes).Account_User_EmailConfirmSend
                      }, _toDisplayString(_unref(localizer).get("Account.Common.EmailConfirmation_Send")), 9, _hoisted_26)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, _toDisplayString(_unref(localizer).get("Account.Common.Password")), 1),
                  _createElementVNode("div", _hoisted_29, [
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      "aria-label": "Password",
                      id: "Password",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.password) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('Password', validationErrors.value) }, 'input w300'])
                    }, null, 2), [
                      [
                        _vModelText,
                        formData.value.password,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      class: _normalizeClass([{ 'fastic-eye-show': isHidden.value, 'fastic-eye-hide': !isHidden.value }, 'showhide']),
                      "aria-label": "Mostra password",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(formHelper).showPassword('Password'), showPasswordIcon()))
                    }, null, 2),
                    _createElementVNode("a", {
                      href: _unref(routes).Account_User_PasswordRemind,
                      class: "link",
                      "data-type": "remind"
                    }, _toDisplayString(_unref(localizer).get("Account.Common.Login_ForgotPassword")), 9, _hoisted_30)
                  ])
                ])
              ]),
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      id: "IsPersistent",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.isPersistent) = $event))
                    }, null, 512), [
                      [
                        _vModelCheckbox,
                        formData.value.isPersistent,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(localizer).get("Account.Login.StayLogged")), 1),
                    _createElementVNode("div", {
                      "data-tooltip": _unref(localizer).get('Account.Login.StayLoggedTooltip'),
                      "data-size": "400"
                    }, [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("span", {
                        class: "icon fastic-support",
                        "aria-hidden": "true"
                      }, null, -1)
                    ]))], 8, _hoisted_34)
                  ])
                ]),
                (validationErrors.value.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("button", {
                    class: _normalizeClass([{ 'loading': isLoading.value }, 'button']),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (submitForm()))
                  }, [
                    (!isLoading.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(localizer).get("Account.Common.Login_Button")), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2)
                ])
              ])
            ], 512)
          ], 32))
        : _createCommentVNode("", true),
      (isTwoFactorVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("h2", _hoisted_39, _toDisplayString(_unref(localizer).get("Account.Common.TwoFactorCode")), 1),
              _createTextVNode(" " + _toDisplayString(_unref(localizer).get("Account.Common.TwoFactorCode_Description")), 1)
            ]),
            _createElementVNode("div", {
              onKeydown: _cache[10] || (_cache[10] = _withKeys(_withModifiers(($event: any) => (submitTwoFactor()), ["prevent","stop"]), ["enter"])),
              class: "form"
            }, [
              _createElementVNode("fieldset", { disabled: isLoading.value }, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", {
                    class: "custominput",
                    "data-type": "two-factor",
                    "aria-label": _unref(localizer).get('Account.Common.TwoFactorCode')
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codeInputArray.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("input", {
                        key: index,
                        type: "text",
                        ref_for: true,
                        ref_key: "codeInputs",
                        ref: codeInputs,
                        class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('Code', validationErrors.value) }, 'input w55']),
                        maxlength: "1",
                        "data-index": item
                      }, null, 10, _hoisted_43))
                    }), 128)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "textbox hidden-input",
                      id: "Code",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((twoFactorData.value.code) = $event)),
                      maxlength: "6",
                      tabindex: "-1"
                    }, null, 512), [
                      [
                        _vModelText,
                        twoFactorData.value.code,
                        void 0,
                        { lazy: true }
                      ]
                    ])
                  ], 8, _hoisted_42),
                  (isTwoFactorRetryVisible.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (sendTwoFactorCode())),
                        class: "link label-link small"
                      }, _toDisplayString(_unref(localizer).get("Account.Common.TwoFactorCode_Send")), 1))
                    : _createCommentVNode("", true)
                ]),
                (validationErrors.value.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("button", {
                      class: _normalizeClass([{ 'loading': isLoading.value }, 'button']),
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (submitTwoFactor()))
                    }, [
                      (!isLoading.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_unref(localizer).get("Account.Common.Login_Button")), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2)
                  ])
                ])
              ], 8, _hoisted_40)
            ], 32)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})